/**
 * @deprecated Use ensureExhaustive in @b2bportal/core-utilities
 *
 * This should not run and is just for Typescript safety
 * @param _
 */
export const exhaustiveTypeCheck = (_: never): never => {
  throw new Error(`Should not be here`);
};
